<template>
  <b-modal v-model="show" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
    <form @submit.prevent="login" class="p-2">
      <b-alert
        variant="danger"
        :show="error !== null"
        dismissible
        @dismissed="error = null"
      >{{ error }}</b-alert>      
      <b-form-group label="Email">
        <b-form-input v-model.trim="email" />
      </b-form-group>
      <b-form-group label="Password">
        <b-form-input v-model.trim="password" type="password" />
      </b-form-group>
      <b-form-group style="float: left; margin-left: 180px">
        <b-button variant="primary" type="submit" :disabled="loading" >Login</b-button>
        <!-- <b-button variant="default" @click="close" :disabled="loading">Thoát</b-button> -->
      </b-form-group>
    </form>
  </b-modal>
</template>

<script>
import axios from "axios";
export default {
  name: "auth-modal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      email: "",
      password: "",
      error: null,
      loading: false,
    };
  },
  methods: {
    login() {
      this.loading = true;
      const payload = {
        email: this.email,
        password: this.password,
      };
      axios
        .post("/api/authentication", payload)
        .then((response) => {          
          const auth = response.data;          
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${auth.accessToken}`;          
          this.$store.commit("loginSuccess", auth);
          this.error = null;
          this.email = "";
          this.password = "";
          this.loading = false;
                    
          if (this.$route.query.redirect) {
            this.$router.push(this.$route.query.redirect);
          }
          else {
            if (this.$store.state.auth.name == this.$booking_account) this.$router.push("/booking");
            else this.$router.push("/");
          }
        })
        .catch((error) => {          
          this.loading = false;
          delete axios.defaults.headers.common["Authorization"];
          this.error = error.response.data;
        });
    },
  },
};
</script>